import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SpecList from "../../components/SpecList";
import SliderImageBox from "../../components/ProductBox/SliderImageBox";
import SpecificationBox from "../../components/ProductBox/SpecificationBox";
const ProducDetails = () => {
  const location = useLocation();
  const [specShow, setSpecShow] = React.useState({
    build: "none",
    processor: "none",
    display: "none",
    frequency: "none",
    memory: "none",
    camera: "none",
    connectivity: "none",
    features: "none",
    battery: "none",
  });
  const key = location && location.state && location.state.products;

  const closeSpecList = (spec) => {
    let status = "none";
    if (specShow[spec] === "none") {
      status = "";
    }
    setSpecShow((prevState) => ({
      ...prevState,
      [spec]: status,
    }));
  };

  const getRows = (spec, specType) => {
    let rows = [];

    const row = (
      <>
        <td className="spec_table_border">
          {key &&
          key.productDetails &&
          key.productDetails[spec] &&
          key.productDetails[spec][specType]
            ? key.productDetails[spec][specType]
            : ""}
        </td>
      </>
    );
    rows.push(row);

    return rows;
  };

  return (
    <section className="product-details" style={{ backgroundColor: "#f0f0f0" }}>
      <div className="container">
        <div className="row">
          <div className="col-12 p0">
            <div className="page-location">
              <ul>
                <li>
                  <a href="#">
                    Home / Shop <span className="divider">/</span>
                  </a>
                </li>
                <li>
                  <a className="page-location-active" href="#">
                    {key && key.name ? key.name : "N/A"}
                    <span className="divider">/</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12 product-details-section">
            <div className="row">
              <div className="product-gallery col-12 col-md-12 col-lg-6">
                <div className="row">
                  <SliderImageBox
                    views={1}
                    images={key && key.image ? [key.image] : []}
                  />
                </div>
              </div>
              <SpecList productInfo={key} />
            </div>
          </div>
        </div>

        {/* <SpecificationBox productInfo={key} heading="Full Specification" /> */}
        <div className="col-12">
          <table className="p0 table table-responsive">
            <tbody>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("build")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Build</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.build,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">OS</td>
                        {getRows("build", "os")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">UI</td>
                        {getRows("build", "ui")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Dimensions
                        </td>
                        {getRows("build", "dimensions")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Weight</td>
                        {getRows("build", "weight")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Sim</td>
                        {getRows("build", "sim")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Colors</td>
                        {getRows("build", "colors")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("processor")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Processor</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.processor,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">Cpu</td>
                        {getRows("processor", "cpu")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Chipset</td>
                        {getRows("processor", "chipset")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">GPU</td>
                        {getRows("processor", "gpu")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("display")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Display</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.display,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Technology
                        </td>
                        {getRows("display", "technology")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Size</td>
                        {getRows("display", "size")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Resolution
                        </td>
                        {getRows("display", "resolution")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Protection
                        </td>
                        {getRows("display", "protection")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Extra Features
                        </td>
                        {getRows("display", "extra_features")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("frequency")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Frequency</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.frequency,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">2g Band</td>
                        {getRows("frequency", "g2_band")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">3g Band</td>
                        {getRows("frequency", "g3_band")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">4g Band</td>
                        {getRows("frequency", "g4_band")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">5g Band</td>
                        {getRows("frequency", "g5_band")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("memory")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Memory</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.memory,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Built In
                        </td>
                        {getRows("memory", "built_in")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Card</td>
                        {getRows("memory", "card")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("camera")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Camera</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.camera,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">Main</td>
                        {getRows("camera", "main")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Features
                        </td>
                        {getRows("camera", "features")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Front</td>
                        {getRows("camera", "front")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("connectivity")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Connectivity</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.connectivity,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">Wlan</td>
                        {getRows("connectivity", "wlan")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Gps</td>
                        {getRows("connectivity", "gps")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Bluetooth
                        </td>
                        {getRows("connectivity", "bluetooth")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Usb</td>
                        {getRows("connectivity", "usb")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Nfc</td>
                        {getRows("connectivity", "nfc")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Radio</td>
                        {getRows("connectivity", "radio_1")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Data</td>
                        {getRows("connectivity", "data")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("features")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Features</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.features,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">Sensors</td>
                        {getRows("features", "sensors")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Audio</td>
                        {getRows("features", "audio")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Browser</td>
                        {getRows("features", "browser")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Messaging
                        </td>
                        {getRows("features", "messaging")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Games</td>
                        {getRows("features", "games")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Torch</td>
                        {getRows("features", "torch")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">Extra</td>
                        {getRows("features", "extra")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div
                    className="compare_hdn"
                    onClick={() => closeSpecList("battery")}
                    style={{ backgroundColor: "whitesmoke" }}
                  >
                    <i className="collapse"></i>
                    <span>Battery</span>
                  </div>
                </td>
              </tr>
              <tr
                className="animate"
                style={{
                  display: specShow.battery,
                }}
              >
                <td colSpan="5">
                  <table className=" table table-responsive">
                    <tbody>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Capacity
                        </td>
                        {getRows("battery", "capacity")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Talktime
                        </td>
                        {getRows("battery", "talktime")}
                      </tr>
                      <tr>
                        <td className="spec_table_border specTitle">
                          Musicplay
                        </td>
                        {getRows("battery", "musicplay")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ProducDetails;
